/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.sessionKey = `${this.id}-shown`;

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!sessionStorage.getItem(this.sessionKey)) {
          // Deferred even for a 0 delay: the constructor runs before the
          // pop-up's children are parsed, so opening here would find no content.
          setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
        }
      }

      /**
       * Opens the modal, recording that it has been shown this session.
       * @param {Element} opener - Modal opener element.
       */
      open(opener) {
        if (!Shopify.designMode) sessionStorage.setItem(this.sessionKey, '1');
        super.open(opener);
      }
    }

    customElements.define('pop-up', PopUp);
  });
}